import { Trans } from 'react-i18next'

import i18n from '@/shared/i18n/i18n'

import { errorActionClass } from './gameErrorActions'
import { ErrorTitleHighlight, GameErrorPage } from './GameErrorPage'

/**
 * Pantalla de «algo se ha roto» compartida por el error boundary global (`AppErrorBoundary`)
 * y el de rutas (`RouteErrorPage`): la carta de «evento imprevisto» (`GameErrorPage`).
 *
 * El boundary global vive POR ENCIMA del proveedor de i18n, así que no hay `useTranslation`:
 * se usa la instancia de i18next, que ya está inicializada al importar el módulo (recursos
 * empaquetados, sin carga asíncrona). Enlaces con `<a>` y no `<Link>`: puede estar fuera del
 * router.
 */
export function ErrorFallback() {
  const t = i18n.t.bind(i18n)
  return (
    <GameErrorPage
      kind="error"
      fullScreen
      eyebrow={t('errorPage.error.eyebrow')}
      title={
        <Trans
          i18n={i18n}
          i18nKey="errorPage.error.title"
          components={{ hl: <ErrorTitleHighlight /> }}
        />
      }
      lead={t('errorPage.error.lead')}
      card={{
        title: t('errorPage.error.cardTitle'),
        effectLabel: t('errorPage.cardEffectLabel'),
        effect: t('errorPage.error.cardEffect'),
        flavor: t('errorPage.error.cardFlavor'),
        back: t('errorPage.cardBack'),
      }}
      actions={
        <>
          <button
            type="button"
            onClick={() => window.location.reload()}
            className={errorActionClass.primary}
          >
            {t('errorPage.error.retry')}
          </button>
          <a href="/" className={errorActionClass.secondary}>
            {t('errorPage.error.home')}
          </a>
        </>
      }
    />
  )
}
